import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RequestService } from '../request/request';
import { AssignFixedAsset, FixedAsset, FixedAssetDTO } from '../../models/fixedasset.interface';
import { Pagination } from '../../models/pagination.interface';
import { QueryGet } from '../../types/query-types';

@Injectable({
  providedIn: 'root',
})
export class FixedassetService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'fixed-assets/';
  url = environment.service_1 + 'all-fixed-assets/';

  urlAdd = environment.service_1 + 'assign-fixed-asset-expense/';
  urlUpdateAdd = environment.service_1 + 'update-assign-fixed-asset-expense/';
  urlDelete = environment.service_1 + 'delete-assign-fixed-asset-expense/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedFixedAsset = new BehaviorSubject<FixedAsset | null>(null);
  selectedFixedAsset$ = this.selectedFixedAsset.asObservable();

  private FixedAssets = new BehaviorSubject<FixedAsset[]>([]);
  FixedAssets$ = this.FixedAssets.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setFixedAsset(fixedAsset: FixedAsset) {
    this.selectedFixedAsset.next(fixedAsset);
  }

  setFixedAssets(fixedAssets: FixedAsset[]) {
    this.FixedAssets.next(fixedAssets);
  }

  removeFixedAssetSelected() {
    this.selectedFixedAsset.next(null);
  }

  createFixedAsset(fixedAsset: FixedAssetDTO) {
    return this.http.post<FixedAsset>(this.urlPath, fixedAsset).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateFixedAsset(id: number, fixedAsset: FixedAssetDTO & { id: number }) {
    return this.http.put<FixedAsset>(this.urlPath + id + '/', fixedAsset).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getFixedAsset(query: QueryGet): Observable<Pagination<FixedAsset[]>> {
    return this.requestService.get<FixedAsset[]>(this.urlPath, query);
  }

  getFixedAssets(): Observable<FixedAsset[]> {
    return this.http.get<FixedAsset[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  addFixedAsset(fixedAsset: AssignFixedAsset) {
    return this.http.post(this.urlAdd, fixedAsset).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  updateAddFixedAsset(id: number, fixedAsset: AssignFixedAsset & { id: number }) {
    return this.http.put(this.urlUpdateAdd + id + '/', fixedAsset).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  deleteAssignFixedAsset(id: number): Observable<void> {
    return this.http.delete<void>(this.urlDelete + id + '/');
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }
}
